import { Injectable, signal } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export interface ImportJobStatus {
  jobId: string;
  progress: number;
  successCount: number;
  failedCount: number;
  status: 'in_progress' | 'success' | 'failed';
  message: string;
}

@Injectable({
  providedIn: 'root',
})
export class ImportJobService {
  
  // Observable for components to subscribe to
  private jobStatusSubject = new BehaviorSubject<ImportJobStatus | null>(null);

  constructor() {}

  /**
   * Update job status
   */
  updateJobStatus(jobData: ImportJobStatus): void {
    this.jobStatusSubject.next(jobData);
  }
  
  /**
   * Get status updates as an Observable (for component subscriptions)
   */
  getStatusUpdates(): Observable<ImportJobStatus | null> {
    return this.jobStatusSubject.asObservable();
  }
}